module.exports = __webpack_public_path__ + "img/icon-button-white.374abd72.svg";